import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";

function RightSlide({ content }) {
  return (
    <div className={ 'slide-grid' }>
      <div className={ 'slide-grid__image-and-quote slide-grid__margin-bottom' }>
        <div className={ 'slide-grid__quote slide-grid__margin-right' }>
          { content.field_slide_2_quote.value &&
          <>”{ content.field_slide_2_quote.value }”</>
          }
        </div>

        <div className={ 'slide-grid__small-image slide-grid__margin-left' }>
          { content.field_slide_2_image_2.value &&
          <ResponsiveImage value={ content.field_slide_2_image_2.value }/>
          }
        </div>
      </div>

      <div className={ 'slide-grid__full-width-image' }>
        { content.field_slide_2_image_1.value &&
        <ResponsiveImage value={ content.field_slide_2_image_1.value }/>
        }
      </div>
    </div>
  );
}

export default RightSlide;
